import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { distributionModels } from "./distribution-models";

// ============================================================================
// distribution_model_lines — child lines of a distribution rule (EPIC #412 4A)
//
// Each row describes ONE allocation slice of the parent rule:
//
//   * Either a doctype-based reference (referenceModule + referenceDoctype +
//     referenceId) — same polymorphic FK pattern as Phase 1's lineRef
//     and Phase 2's `accounting_je_item_allocations`.
//   * Or a standalone-dimension reference (dimensionTypeId + dimensionValueId)
//     — Phase 3 dimension catalogue.
//
// `percentage` is 0–100 and the route validates `sum(percentage) === 100`
// before saving (or 100 ± 0.01 tolerance to absorb the user's last-row
// rounding). `sortOrder` controls which row absorbs the rounding remainder
// when the resolver expands amounts (last-allocation-absorbs-remainder —
// see `expandJeItemToGlLines`).
//
// CASCADE on parent delete — deleting a rule kills its lines. The route
// uses soft-delete (isActive=0) on the parent, so this only fires for
// hard deletes that bypass the API.
// ============================================================================

export const distributionModelLines = sqliteTable("accounting_distribution_model_lines", {
  id: text("id").primaryKey(), // ULID
  modelId: text("model_id")
    .notNull()
    .references(() => distributionModels.id, { onDelete: "cascade" }),

  // Doctype-based dimension (Phase 1/2 pattern, polymorphic FK).
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),

  // Standalone dimension (Phase 3 catalogue).
  dimensionTypeId: text("dimension_type_id"),
  dimensionValueId: text("dimension_value_id"),

  percentage: real("percentage").notNull(),
  sortOrder: integer("sort_order").notNull().default(0),
}, (table) => ({
  distLineModelIdx: index("dist_line_model_idx").on(table.modelId),
}));

export type DistributionModelLine = typeof distributionModelLines.$inferSelect;
export type NewDistributionModelLine = typeof distributionModelLines.$inferInsert;
